"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getMetadata;
const asError_1 = __importDefault(require("./asError"));
function getMetadata(error) {
    const typedError = (0, asError_1.default)(error);
    return {
        errorName: typedError.name,
        errorMessage: typedError.message,
        errorStack: typedError.stack,
    };
}
//# sourceMappingURL=getMetadata.js.map